{
  "assets": {
    "MapIcon": "Icône",
    "Model": "Modèle 3D",
    "none_selected_warning": "Vous devez avoir sélectionné un {{ assetType }}",
    "all_categories": "Toutes les catégories",
    "select": "Sélectionnez {{ assetType }}",
    "search_placeholder": "Recherchez {{ assetType }}"
  },
  "layerTemplates": {
    "selectTemplateText": "Modèles de couches de recherche",
    "createCustomLayer": "Créer une couche personnalisée",
    "startFromScratch": "commencer une nouvelle couche à partir de zéro",
    "failedToLoadTemplates": "Impossible de charger les modèles de couches",
    "failedToLoadLayer": "Impossible de charger la couche",
    "noLayerTemplates": "Nous ne trouvons aucun modèle portant ce nom. Souhaitez-vous créer une nouvelle couche sans utiliser de modèle à la place ?",
    "searchPlaceholder": "Par exemple, les transports",
    "allTemplates": "Tous les modèles",
    "searchResults": "Résultats de recherche"
  },
  "toolbarButtonTooltips": {
    "draw_map_object": "Dessiner",
    "undo": "Annuler",
    "redo": "Refaire",
    "copy_map_objects": "Copier/Coller",
    "draw_analysis_line": "Tracer une ligne",
    "draw_analysis_polygon": "Dessiner un polygone",
    "draw_rectangle": "Dessiner un rectangle",
    "draw_point": "Point de dessin",
    "draw_icon": "Icône de dessin",
    "draw_model": "Dessiner un modèle",
    "draw_line_model": "Modèle de ligne de dessin",
    "snapping_tools": "Paramètres de capture"
  },
  "sidebarButtonTooltips": {
    "new_layer": "Créer une couche à partir d'un modèle",
    "import_layer": "Importer des couches depuis d'autres plans",
    "attribute_data_table": "Tableau de données attributaires",
    "toggle_all_layers_visibility": "Activer/désactiver la visibilité de toutes les couches",
    "hide_all_layers": "Masquer toutes les couches",
    "show_all_layers": "Afficher toutes les couches",
    "change_log": "Journal des modifications"
  },
  "toggleAllLayersVisibilityConfirmation": {
    "title": "Activer/désactiver la visibilité de toutes les couches",
    "message": "Cela modifiera la visibilité de toutes les couches pour tous les utilisateurs. Êtes-vous sûr de vouloir continuer ?"
  },
  "layerOptionsTooltips": {
    "layer_information": "Informations sur la couche",
    "layer_view_options": "Options d'affichage des couches",
    "hide_layer": "Masquer la couche",
    "show_layer": "Afficher la couche"
  },
  "backgroundMapSelector": {
    "background_map_options": "Options d'arrière-plan",
    "recommended": "Recommandé",
    "configure": "Configurez"
  },
  "sitemaps": {
    "no_sitemaps_available": "Aucun plan du site à cet endroit.\nLes sitemaps sont des cartes détaillées des emplacements, telles que des dessins CAO montrant l'aménagement intérieur d'un bâtiment.",
    "no_sitemaps_available_2": "\npour en savoir plus sur l'ajout de sitemaps"
  },
  "drawing_tooltips": {
    "title": "Outils de dessin",
    "enter_edit_mode": "Cliquez ici, puis cliquez sur la carte pour commencer à dessiner",
    "enter_edit_mode_no_layers": "Pour commencer à dessiner sur la carte, créez (ou sélectionnez) une couche à l'aide du panneau de gauche",
    "enter_composition_part_1": "Cliquez sur la carte pour ajouter des points. Double-cliquez ou appuyez sur",
    "enter_composition_part_2": "pour terminer."
  },
  "search_tooltip": {
    "set_save_title": "Définir cet emplacement par défaut pour le plan ?",
    "set_save_content": "Le plan reviendra à cet emplacement la prochaine fois que vous l'ouvrirez.",
    "set_save_save": "Enregistrer la vue",
    "set_save_dismiss": "Peut-être plus tard",
    "save_info_title": "Vues enregistrées",
    "save_info_content": "Vous pouvez gérer les vues de plan enregistrées ou modifier la valeur par défaut de votre plan dans le menu de recherche.",
    "save_info_got_it": "J'ai compris"
  },
  "attributes": {
    "allowed_metadata_properties": "Propriétés de métadonnées autorisées",
    "required": "Nécessaire",
    "system_datafield_type": "Type de champ de données du système"
  },
  "map_tour": {
    "tip_3_location": {
      "title": "Trouvez un lieu",
      "content": "Ici, vous pouvez rechercher des lieux sur le plan, tels que des rues, des lieux ou des objets que vous avez placés. Vous pouvez également enregistrer des emplacements importants vers lesquels vous pouvez accéder et définir une valeur par défaut pour votre plan."
    },
    "tip_4_background": {
      "title": "Choisissez l'arrière-plan de votre carte",
      "content": "Ici, vous pouvez choisir parmi différents arrière-plans de carte, tels que des images satellites ou des fournisseurs de cartes locaux. Vous pouvez également définir l'arrière-plan par défaut."
    },
    "tip_5_layer": {
      "title": "Créez votre première couche",
      "content": "Pour commencer à dessiner, créez une nouvelle couche."
    }
  },
  "zoomableValues": {
    "fixed": "Fixé",
    "by_zoom_level": "Par Zoom Level",
    "edit_zoom_levels": "Modifier les niveaux de zoom",
    "predefined": "Prédéfini",
    "custom": "Personnalisé",
    "hide": "Masquer",
    "add_zoom_level": "Ajouter un nouveau niveau de zoom",
    "zoom_options": "Options de zoom",
    "zoom_levels": "Niveaux de zoom",
    "street_level": "Au niveau de la rue",
    "city_level": "Au niveau de la ville",
    "country_level": "Au niveau des pays",
    "world_level": "Au niveau mondial",
    "max_level": "Au niveau de zoom maximal"
  },
  "sidebarToolbar": {
    "share": "Plan de partage"
  },
  "units": {
    "pixels": "Pixels",
    "degrees": "Diplômes",
    "scale": "Échelle",
    "meters": "Compteurs"
  }
}